/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />


module Eseebase {

    export class UniversalStorageViewModel {
        id: string;
        fileName: string;
        associationId: string;
        departmentId: string;
        localizer: string;
        localizers: string[];
        menuExpanded: boolean;
        tags: string[];
        url: string;
        smallUrl: string;
        mediumUrl: string;
        description: string;
        isEditingDescription: boolean;
        isEditingIssueDate: boolean;
        active: boolean;
        timestamp: string;
        issueDate: string;
        issueDateDp: Date;
        searchText: string;
        suggestedTags: string[];
        constructor() {
            this.isEditingDescription = false;
            this.searchText = '';
            this.suggestedTags = [];
        }
    }

    export class UniversalStoragePagedResult {
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        pageSize: number;
        results: UniversalStorageViewModel[];
        isLoading: boolean;
        pageNumber: number;
        scrollId: string;
        isLastPage: boolean;
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
            this.pageSize = 10;
            this.pageNumber = 1;
            this.totalNumberOfPages = 10;
            this.isLastPage = false;
        }
    }

    export class TagsWrapperModel {
        tags: string[];
    }
}